"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FingerprintModelToJSON = exports.FingerprintModelFromJSONTyped = exports.FingerprintModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function FingerprintModelFromJSON(json) {
    return FingerprintModelFromJSONTyped(json, false);
}
exports.FingerprintModelFromJSON = FingerprintModelFromJSON;
function FingerprintModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'created': !runtime_1.exists(json, 'created') ? undefined : (new Date(json['created'])),
        'mimeType': !runtime_1.exists(json, 'mimeType') ? undefined : json['mimeType'],
        'scanMetaData': !runtime_1.exists(json, 'scanMetaData') ? undefined : _1.KojakScanMetadataModelFromJSON(json['scanMetaData']),
    };
}
exports.FingerprintModelFromJSONTyped = FingerprintModelFromJSONTyped;
function FingerprintModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'mimeType': value.mimeType,
        'scanMetaData': _1.KojakScanMetadataModelToJSON(value.scanMetaData),
    };
}
exports.FingerprintModelToJSON = FingerprintModelToJSON;
//# sourceMappingURL=FingerprintModel.js.map